module.exports = __webpack_public_path__ + "static/gamer-girl-3444e44aad936d451e4e23cd1f1b0b54.jpg";